import React from 'react';
import {Link, useHistory} from 'react-router-dom';
import {Buttons, Grid, Modal, Structure, Typography} from 'components';
import config from 'config';
import {useError, useUser} from 'hooks';
import {AutoLogoutModal} from 'macros';
import {modal, parseQueryArgs} from 'utils';

import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '180px 0px',
        height: '100%',
        minHeight: 'inherit',
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg-error.jpg)`,
        backgroundPosition: 'right top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },
    logo: {
        position: 'absolute',
        top: 20,
        width: 42,
        height: 42
    }
}));

const ErrorModal = () => {
    const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

    const {error} = useError();

    if (ENVIRONMENT === 'production') return null;

    if (error === null) return null;

    return (
        <>
            <Buttons.Chevron
                label="Voir l'erreur"
                color="white"
                onClick={() => modal.open('error')}
            />
            <Modal
                title={`Erreur ${error.status} de ${error.data?.service || 'source inconnue'}`}
                hash="error"
            >
                {error.data && <Typography variant="h6">{error.data.message || 'Une erreur est survenue'}</Typography>}
                <pre>{JSON.stringify(error, null, 4)}</pre>
            </Modal>
        </>
    );
};

function Error() {
    const classes = useStyles();

    const history = useHistory();

    const reason = parseQueryArgs().reason;

    const {user} = useUser();

    return (
        <>
            <Structure.Center>
                <Link to="/">
                    <img
                        className={classes.logo}
                        src={`${process.env.PUBLIC_URL}/logos/axa.svg`}
                        alt="logo"
                    />
                </Link>
            </Structure.Center>

            <div className={classes.container}>
                <Structure.Center>
                    {reason === 'ERR_CONSENT' && (
                        <>
                            <Typography
                                variant="h5"
                                color="white"
                                width={420}
                            >
                                Le client n'a pas donné son consentement pour la visualisation de ses données&nbsp;
                                <Typography
                                    component="span"
                                    semibold
                                >
                                    Ma Retraite 360
                                </Typography>
                                .
                            </Typography>
                            <Buttons.Default
                                label="Retour"
                                color="green"
                                next
                                onClick={() => window.history.back()}
                            />
                        </>
                    )}

                    {reason === 'ERR_DEPLOYMENT' && (
                        <>
                            <Typography
                                variant="h4"
                                color="white"
                                width={420}
                                semibold
                                caps
                            >
                                site en cours de maintenance&nbsp;
                            </Typography>
                            <Typography
                                variant="h5"
                                color="white"
                                width={420}
                            >
                                Veuillez nous excuser pour la gêne occasionnée. Merci de réessayer ultérieurement.
                            </Typography>
                        </>
                    )}

                    {reason === 'ERR_NOT_FOUND' && (
                        <>
                            <Typography
                                variant="h4"
                                color="white"
                                width={420}
                                semibold
                            >
                                Erreur 404&nbsp;
                            </Typography>
                            <Typography
                                variant="h5"
                                color="white"
                                width={420}
                            >
                                Page non trouvée
                            </Typography>
                            <Buttons.Default
                                label="Retour à l'accueil"
                                color="green"
                                next
                                onClick={() => history.push('/')}
                            />
                        </>
                    )}

                    {!reason && ['individual', 'individual_transmission'].includes(user.origin) && (
                        <>
                            <Typography
                                variant="h3"
                                color="white"
                                semibold
                                caps
                            >
                                Service momentanément indisponible.
                            </Typography>
                            <Typography
                                variant="h5"
                                color="white"
                                width={420}
                            >
                                <br />
                                Le service demandé est momentanément indisponible. Veuillez nous excuser pour la gêne
                                occasionnée. Merci de réessayer ultérieurement.
                                <br />
                                <br />
                            </Typography>
                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item>
                                    <Buttons.Default
                                        hash="individual_error_redirect"
                                        label="Mon Espace Client"
                                        color="orange"
                                        next
                                        onClick={() => {
                                            window.location.href = `${
                                                config.AXA_CLIENT_SPACE_URL[process.env.REACT_APP_ENVIRONMENT]
                                            }`;
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {!reason && !['individual', 'individual_transmission'].includes(user.origin) && (
                        <>
                            <Typography
                                variant="h5"
                                color="white"
                                semibold
                                width={420}
                            >
                                Une opération de maintenance de votre site <br />
                                Axa Mon Epargne Entreprise est en cours.
                            </Typography>
                            <Typography
                                variant="h5"
                                color="white"
                                width={420}
                            >
                                <br />
                                Nous nous excusons pour la gêne occasionnée.
                                <br />
                                <br />
                            </Typography>
                        </>
                    )}

                    <ErrorModal />
                </Structure.Center>
            </div>

            <AutoLogoutModal />
        </>
    );
}

export default Error;
